import { render, staticRenderFns } from "./ThreadRequiresUserAttentionIcon.vue?vue&type=template&id=5942e9ab&scoped=true"
import script from "./ThreadRequiresUserAttentionIcon.vue?vue&type=script&lang=js"
export * from "./ThreadRequiresUserAttentionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942e9ab",
  null
  
)

export default component.exports